import { DocStatesEnum } from '../../openapi/types/DocStatesEnum';

const RENAMED_DOC_STATES: Record<string, DocStatesEnum> = {
  REJECTED_BY_OWNER: DocStatesEnum.REJECTED_BY_COUNTERPART,
};

const DOC_FILTER_LISTS = ['docList', 'checkList'] as const;
const DOC_STATE_PARAMS = ['state', 'state__in', 'state__not_in'] as const;

type StoredFilters = Record<string, unknown>;

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const renameState = (value: unknown) =>
  typeof value === 'string' ? (RENAMED_DOC_STATES[value] ?? value) : value;

const migrateStateParam = (value: unknown) =>
  Array.isArray(value) ? value.map(renameState) : renameState(value);

const migrateDocFilter = (docFilter: Record<string, unknown>) => {
  const migrated = { ...docFilter };
  DOC_STATE_PARAMS.forEach((param) => {
    if (param in migrated) {
      migrated[param] = migrateStateParam(migrated[param]);
    }
  });
  return migrated;
};

export const migrateRenamedDocStates = <T extends StoredFilters>(storedFilters: T): T => {
  if (!isRecord(storedFilters)) {
    return storedFilters;
  }

  const migrated: StoredFilters = { ...storedFilters };
  DOC_FILTER_LISTS.forEach((list) => {
    const docFilter = migrated[list];
    if (isRecord(docFilter)) {
      migrated[list] = migrateDocFilter(docFilter);
    }
  });
  return migrated as T;
};
